import { Star, Truck, ShieldCheck, CreditCard, Clock } from 'lucide-react';

export const TrustBanner = () => {
  return (
    <section className="py-6 bg-[#F5F5F0] border-y border-[#E5E7EB]" data-testid="trust-banner">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
          <div className="flex items-center gap-3">
            <div className="flex text-amber-400">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" />)}
            </div>
            <div>
              <p className="text-xs font-semibold text-[#2C332E]">4.8 / 5</p>
              <p className="text-[10px] text-[#6B7280]">1.200+ Bewertungen</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <Truck className="w-5 h-5 text-[#4A5D4F] flex-shrink-0" />
            <div>
              <p className="text-xs font-semibold text-[#2C332E]">Schneller Versand</p>
              <p className="text-[10px] text-[#6B7280]">2-4 Werktage</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <ShieldCheck className="w-5 h-5 text-[#4A5D4F] flex-shrink-0" />
            <div>
              <p className="text-xs font-semibold text-[#2C332E]">Sichere Zahlung</p>
              <p className="text-[10px] text-[#6B7280]">SSL-verschlüsselt</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <CreditCard className="w-5 h-5 text-[#4A5D4F] flex-shrink-0" />
            <div>
              <p className="text-xs font-semibold text-[#2C332E]">PayPal & Karte</p>
              <p className="text-[10px] text-[#6B7280]">Apple Pay, Google Pay</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5 col-span-2 md:col-span-1">
            <Clock className="w-5 h-5 text-[#4A5D4F] flex-shrink-0" />
            <div>
              <p className="text-xs font-semibold text-[#2C332E]">Noch vor Eid</p>
              <p className="text-[10px] text-[#6B7280]">Rechtzeitig bestellen</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
